(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@babel/runtime-corejs3/core-js-stable/instance/concat"), require("@babel/runtime-corejs3/core-js-stable/set-timeout"), require("@babel/runtime-corejs3/core-js-stable/instance/splice"), require("@babel/runtime-corejs3/core-js-stable/instance/index-of"), require("@babel/runtime-corejs3/core-js-stable/instance/every"), require("@babel/runtime-corejs3/core-js-stable/instance/for-each"), require("@babel/runtime-corejs3/regenerator"), require("@babel/runtime-corejs3/helpers/asyncToGenerator"), require("@babel/runtime-corejs3/helpers/classCallCheck"), require("@babel/runtime-corejs3/helpers/createClass"), require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs3/helpers/getPrototypeOf"), require("@babel/runtime-corejs3/helpers/assertThisInitialized"), require("@babel/runtime-corejs3/helpers/inherits"), require("@babel/runtime-corejs3/helpers/defineProperty"), require("@babel/runtime-corejs3/core-js/get-iterator"), require("@babel/runtime-corejs3/core-js-stable/instance/sort"), require("@babel/runtime-corejs3/helpers/toConsumableArray"), require("@babel/runtime-corejs3/core-js-stable/instance/last-index-of"), require("@babel/runtime-corejs3/core-js-stable/parse-int"), require("@babel/runtime-corejs3/core-js-stable/instance/filter"), require("@babel/runtime-corejs3/core-js-stable/instance/map"), require("@babel/runtime-corejs3/core-js-stable/map"), require("@babel/runtime-corejs3/core-js-stable/instance/includes"), require("@babel/runtime-corejs3/core-js-stable/instance/some"), require("@babel/runtime-corejs3/helpers/typeof"), require("@babel/runtime-corejs3/core-js-stable/instance/bind"), require("react"), require("@babel/runtime-corejs3/helpers/objectSpread"));
	else if(typeof define === 'function' && define.amd)
		define(["@babel/runtime-corejs3/core-js-stable/instance/concat", "@babel/runtime-corejs3/core-js-stable/set-timeout", "@babel/runtime-corejs3/core-js-stable/instance/splice", "@babel/runtime-corejs3/core-js-stable/instance/index-of", "@babel/runtime-corejs3/core-js-stable/instance/every", "@babel/runtime-corejs3/core-js-stable/instance/for-each", "@babel/runtime-corejs3/regenerator", "@babel/runtime-corejs3/helpers/asyncToGenerator", "@babel/runtime-corejs3/helpers/classCallCheck", "@babel/runtime-corejs3/helpers/createClass", "@babel/runtime-corejs3/helpers/possibleConstructorReturn", "@babel/runtime-corejs3/helpers/getPrototypeOf", "@babel/runtime-corejs3/helpers/assertThisInitialized", "@babel/runtime-corejs3/helpers/inherits", "@babel/runtime-corejs3/helpers/defineProperty", "@babel/runtime-corejs3/core-js/get-iterator", "@babel/runtime-corejs3/core-js-stable/instance/sort", "@babel/runtime-corejs3/helpers/toConsumableArray", "@babel/runtime-corejs3/core-js-stable/instance/last-index-of", "@babel/runtime-corejs3/core-js-stable/parse-int", "@babel/runtime-corejs3/core-js-stable/instance/filter", "@babel/runtime-corejs3/core-js-stable/instance/map", "@babel/runtime-corejs3/core-js-stable/map", "@babel/runtime-corejs3/core-js-stable/instance/includes", "@babel/runtime-corejs3/core-js-stable/instance/some", "@babel/runtime-corejs3/helpers/typeof", "@babel/runtime-corejs3/core-js-stable/instance/bind", "react", "@babel/runtime-corejs3/helpers/objectSpread"], factory);
	else if(typeof exports === 'object')
		exports["Webcam"] = factory(require("@babel/runtime-corejs3/core-js-stable/instance/concat"), require("@babel/runtime-corejs3/core-js-stable/set-timeout"), require("@babel/runtime-corejs3/core-js-stable/instance/splice"), require("@babel/runtime-corejs3/core-js-stable/instance/index-of"), require("@babel/runtime-corejs3/core-js-stable/instance/every"), require("@babel/runtime-corejs3/core-js-stable/instance/for-each"), require("@babel/runtime-corejs3/regenerator"), require("@babel/runtime-corejs3/helpers/asyncToGenerator"), require("@babel/runtime-corejs3/helpers/classCallCheck"), require("@babel/runtime-corejs3/helpers/createClass"), require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs3/helpers/getPrototypeOf"), require("@babel/runtime-corejs3/helpers/assertThisInitialized"), require("@babel/runtime-corejs3/helpers/inherits"), require("@babel/runtime-corejs3/helpers/defineProperty"), require("@babel/runtime-corejs3/core-js/get-iterator"), require("@babel/runtime-corejs3/core-js-stable/instance/sort"), require("@babel/runtime-corejs3/helpers/toConsumableArray"), require("@babel/runtime-corejs3/core-js-stable/instance/last-index-of"), require("@babel/runtime-corejs3/core-js-stable/parse-int"), require("@babel/runtime-corejs3/core-js-stable/instance/filter"), require("@babel/runtime-corejs3/core-js-stable/instance/map"), require("@babel/runtime-corejs3/core-js-stable/map"), require("@babel/runtime-corejs3/core-js-stable/instance/includes"), require("@babel/runtime-corejs3/core-js-stable/instance/some"), require("@babel/runtime-corejs3/helpers/typeof"), require("@babel/runtime-corejs3/core-js-stable/instance/bind"), require("react"), require("@babel/runtime-corejs3/helpers/objectSpread"));
	else
		root["Webcam"] = factory(root["@babel/runtime-corejs3/core-js-stable/instance/concat"], root["@babel/runtime-corejs3/core-js-stable/set-timeout"], root["@babel/runtime-corejs3/core-js-stable/instance/splice"], root["@babel/runtime-corejs3/core-js-stable/instance/index-of"], root["@babel/runtime-corejs3/core-js-stable/instance/every"], root["@babel/runtime-corejs3/core-js-stable/instance/for-each"], root["@babel/runtime-corejs3/regenerator"], root["@babel/runtime-corejs3/helpers/asyncToGenerator"], root["@babel/runtime-corejs3/helpers/classCallCheck"], root["@babel/runtime-corejs3/helpers/createClass"], root["@babel/runtime-corejs3/helpers/possibleConstructorReturn"], root["@babel/runtime-corejs3/helpers/getPrototypeOf"], root["@babel/runtime-corejs3/helpers/assertThisInitialized"], root["@babel/runtime-corejs3/helpers/inherits"], root["@babel/runtime-corejs3/helpers/defineProperty"], root["@babel/runtime-corejs3/core-js/get-iterator"], root["@babel/runtime-corejs3/core-js-stable/instance/sort"], root["@babel/runtime-corejs3/helpers/toConsumableArray"], root["@babel/runtime-corejs3/core-js-stable/instance/last-index-of"], root["@babel/runtime-corejs3/core-js-stable/parse-int"], root["@babel/runtime-corejs3/core-js-stable/instance/filter"], root["@babel/runtime-corejs3/core-js-stable/instance/map"], root["@babel/runtime-corejs3/core-js-stable/map"], root["@babel/runtime-corejs3/core-js-stable/instance/includes"], root["@babel/runtime-corejs3/core-js-stable/instance/some"], root["@babel/runtime-corejs3/helpers/typeof"], root["@babel/runtime-corejs3/core-js-stable/instance/bind"], root["React"], root["@babel/runtime-corejs3/helpers/objectSpread"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_26__, __WEBPACK_EXTERNAL_MODULE_27__, __WEBPACK_EXTERNAL_MODULE_28__, __WEBPACK_EXTERNAL_MODULE_30__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Webcam; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_set_timeout__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_set_timeout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_set_timeout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_splice__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_splice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_splice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_index_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_every__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_for_each__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_for_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_for_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_helpers_getPrototypeOf__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_helpers_assertThisInitialized__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs3_helpers_inherits__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs3_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs3_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_runtime_corejs3_core_js_get_iterator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__babel_runtime_corejs3_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__babel_runtime_corejs3_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_corejs3_core_js_stable_instance_sort__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_corejs3_core_js_stable_instance_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__babel_runtime_corejs3_core_js_stable_instance_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__babel_runtime_corejs3_core_js_stable_instance_last_index_of__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__babel_runtime_corejs3_core_js_stable_instance_last_index_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__babel_runtime_corejs3_core_js_stable_instance_last_index_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__babel_runtime_corejs3_core_js_stable_parse_int__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__babel_runtime_corejs3_core_js_stable_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__babel_runtime_corejs3_core_js_stable_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__babel_runtime_corejs3_core_js_stable_map__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__babel_runtime_corejs3_core_js_stable_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__babel_runtime_corejs3_core_js_stable_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__babel_runtime_corejs3_core_js_stable_instance_some__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__babel_runtime_corejs3_core_js_stable_instance_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__babel_runtime_corejs3_core_js_stable_instance_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__babel_runtime_corejs3_core_js_stable_instance_bind__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__babel_runtime_corejs3_core_js_stable_instance_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__babel_runtime_corejs3_core_js_stable_instance_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__video__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_enumerate_devices__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_enumerate_devices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_enumerate_devices__);




























var _context;





/*
Deliberately ignoring the old api, due to very inconsistent behaviour
*/

var mediaDevices = navigator.mediaDevices;
var getUserMedia = mediaDevices && mediaDevices.getUserMedia ? __WEBPACK_IMPORTED_MODULE_26__babel_runtime_corejs3_core_js_stable_instance_bind___default()(_context = mediaDevices.getUserMedia).call(_context, mediaDevices) : null;
var hasGetUserMedia = !!getUserMedia;

var handleFacingModeConstraints = function handleFacingModeConstraints(constraints) {
  if (constraints && __WEBPACK_IMPORTED_MODULE_25__babel_runtime_corejs3_helpers_typeof___default()(constraints.video) === 'object') {
    var facingMode = constraints.video.facingMode; // To detect an environment or rear facing camera, the constraint can be passed in as {facingMode: "environment"} or {facingMode: {exact: "environment"}};
    // this will account for either situation. "facingMode && facingMode.exact &&" is necessary before checking facingMode.exact to avoid an error if facingMode is undefined or doesn't contain the exact key

    var shouldUseBackCam = facingMode === "environment" || __WEBPACK_IMPORTED_MODULE_25__babel_runtime_corejs3_helpers_typeof___default()(facingMode) === 'object' && facingMode.exact && facingMode.exact === "environment";
    if (!shouldUseBackCam) return constraints;
    return __WEBPACK_IMPORTED_MODULE_30_enumerate_devices___default()().then(function (devices) {
      var cameras = extractCamerasFromDevices(devices);
      var mainBackCam = mainBackCamera(cameras);

      if (mainBackCam && mainBackCam.deviceId === "") {
        constraints.video.facingMode = {
          ideal: "environment"
        };
      } else {
        var deviceId = mainBackCam && mainBackCam.deviceId ? mainBackCam.deviceId : cameras[0].deviceId;
        constraints.video.deviceId = {
          exact: deviceId
        };
      }

      return constraints;
    });
  }
};

var isBackCameraLabel = function isBackCameraLabel(label) {
  var lowercaseLabel = label.toLowerCase();
  return __WEBPACK_IMPORTED_MODULE_24__babel_runtime_corejs3_core_js_stable_instance_some___default()(__WEBPACK_IMPORTED_MODULE_29__utils__["a" /* backCameraKeywords */]).call(__WEBPACK_IMPORTED_MODULE_29__utils__["a" /* backCameraKeywords */], function (keyword) {
    return __WEBPACK_IMPORTED_MODULE_23__babel_runtime_corejs3_core_js_stable_instance_includes___default()(lowercaseLabel).call(lowercaseLabel, keyword);
  });
};

var cameraObjects = new __WEBPACK_IMPORTED_MODULE_22__babel_runtime_corejs3_core_js_stable_map___default.a();

var extractCamerasFromDevices = function extractCamerasFromDevices(devices) {
  var _context2;

  var cameras = __WEBPACK_IMPORTED_MODULE_21__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context2 = __WEBPACK_IMPORTED_MODULE_20__babel_runtime_corejs3_core_js_stable_instance_filter___default()(devices).call(devices, function (device) {
    return device.kind === "videoinput";
  })).call(_context2, function (videoDevice) {
    if (cameraObjects.has(videoDevice.deviceId)) {
      return cameraObjects.get(videoDevice.deviceId);
    }

    var label = videoDevice.label !== null ? videoDevice.label : "";
    var camera = {
      deviceId: videoDevice.deviceId,
      label: label,
      cameraType: isBackCameraLabel(label) ? 'back' : 'front'
    };

    if (label !== "") {
      cameraObjects.set(videoDevice.deviceId, camera);
    }

    return camera;
  });

  if (cameras.length > 1 && !__WEBPACK_IMPORTED_MODULE_24__babel_runtime_corejs3_core_js_stable_instance_some___default()(cameras).call(cameras, function (camera) {
    return camera.cameraType === 'back';
  })) {
    // Check if cameras are labeled with resolution information, take the higher-resolution one in that case
    // Otherwise pick the last camera
    var backCameraIndex = cameras.length - 1;

    var cameraResolutions = __WEBPACK_IMPORTED_MODULE_21__babel_runtime_corejs3_core_js_stable_instance_map___default()(cameras).call(cameras, function (camera) {
      var match = camera.label.match(/\b([0-9]+)MP?\b/i);

      if (match) {
        return __WEBPACK_IMPORTED_MODULE_19__babel_runtime_corejs3_core_js_stable_parse_int___default()(match[1], 10);
      }

      return NaN;
    });

    if (!__WEBPACK_IMPORTED_MODULE_24__babel_runtime_corejs3_core_js_stable_instance_some___default()(cameraResolutions).call(cameraResolutions, function (cameraResolution) {
      return isNaN(cameraResolution);
    })) {
      backCameraIndex = __WEBPACK_IMPORTED_MODULE_18__babel_runtime_corejs3_core_js_stable_instance_last_index_of___default()(cameraResolutions).call(cameraResolutions, Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_17__babel_runtime_corejs3_helpers_toConsumableArray___default()(cameraResolutions)));
    }

    cameras[backCameraIndex].cameraType = 'back';
  }

  return cameras;
};

var mainBackCamera = function mainBackCamera(cameras) {
  var _context3;

  return __WEBPACK_IMPORTED_MODULE_16__babel_runtime_corejs3_core_js_stable_instance_sort___default()(_context3 = __WEBPACK_IMPORTED_MODULE_20__babel_runtime_corejs3_core_js_stable_instance_filter___default()(cameras).call(cameras, function (camera) {
    return camera.cameraType === 'back';
  })).call(_context3, function (camera1, camera2) {
    return camera1.label.localeCompare(camera2.label);
  })[0];
};

var DEBUG = false;

var debugConsole = function debugConsole() {
  var _console;

  if (DEBUG) (_console = console).log.apply(_console, arguments);
};

var permissionErrors = ['PermissionDeniedError', 'NotAllowedError', 'NotFoundError'];

var stopStreamTracks = function stopStreamTracks(stream) {
  if (stream && stream.getVideoTracks) {
    // check for stream first AND stream.getVideoTracks
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_15__babel_runtime_corejs3_core_js_get_iterator___default()(stream.getVideoTracks()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var track = _step.value;
        track.stop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  if (stream && stream.getAudioTracks) {
    // check for stream first AND stream.getAudioTracks
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_15__babel_runtime_corejs3_core_js_get_iterator___default()(stream.getAudioTracks()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _track = _step2.value;

        _track.stop();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
};

var Webcam =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs3_helpers_inherits___default()(Webcam, _Component);

  function Webcam(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_helpers_classCallCheck___default()(this, Webcam);

    _this = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_helpers_getPrototypeOf___default()(Webcam).call(this, props));

    __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_helpers_assertThisInitialized___default()(_this), "state", {
      hasUserMedia: false,
      mirrored: false
    });

    __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_helpers_assertThisInitialized___default()(_this), "updateVideoElement", function () {
      var video = _this.video;

      if (video) {
        // The muted attributed is not currently being set due to a bug in react
        // see: https://github.com/facebook/react/issues/10389
        video.setAttribute('muted', 'true');
      }
    });

    if (!hasGetUserMedia) {
      var error = new Error('getUserMedia is not supported by this browser');

      _this.props.onFailure(error);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_helpers_createClass___default()(Webcam, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_helpers_asyncToGenerator___default()(
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                Webcam.mountedInstances.push(this);
                _context4.next = 3;
                return this.requestUserMedia();

              case 3:
                this.updateVideoElement();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateVideoElement();
    }
  }, {
    key: "getConstraints",
    value: function getConstraints(width, height, facingMode, audio) {
      /*
      Safari 11 has a bug where if you specify both the height and width
      constraints you must chose a resolution supported by the web cam. If an
      unsupported resolution is used getUserMedia(constraints) will hit a
      OverconstrainedError complaining that width is an invalid constraint.
      This bug exists for ideal constraints as well as min and max.
       However if only a height is specified safari will correctly chose the
      nearest resolution supported by the web cam.
       Reference: https://developer.mozilla.org/en-US/docs/Web/API/Media_Streams_API/Constraints
      */
      // if `{facingMode: 'user'}` Firefox will still allow the user to choose which camera to use (Front camera will be the first option)
      var constraints = {
        video: {
          facingMode: facingMode
        },
        audio: audio
      };

      if (width) {
        constraints.video.width = __WEBPACK_IMPORTED_MODULE_19__babel_runtime_corejs3_core_js_stable_parse_int___default()(width, 10) || width; // some devices need a Number type
      }

      if (height) {
        constraints.video.height = __WEBPACK_IMPORTED_MODULE_19__babel_runtime_corejs3_core_js_stable_parse_int___default()(height, 10) || height;
      }

      return constraints;
    }
  }, {
    key: "requestUserMedia",
    value: function () {
      var _requestUserMedia = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_helpers_asyncToGenerator___default()(
      /*#__PURE__*/
      __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator___default.a.mark(function _callee2() {
        var _this$props, width, height, facingMode, audio, fallbackWidth, fallbackHeight, constraints, fallbackConstraints, logError, onSuccess, hasTriedFallbackConstraints, onError, _context7, devices, hasDevicePermission, _context8, mediaStream;

        return __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee2$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(!getUserMedia || !mediaDevices || Webcam.userMediaRequested)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return");

              case 2:
                _this$props = this.props, width = _this$props.width, height = _this$props.height, facingMode = _this$props.facingMode, audio = _this$props.audio, fallbackWidth = _this$props.fallbackWidth, fallbackHeight = _this$props.fallbackHeight;
                constraints = this.getConstraints(width, height, facingMode, audio);
                fallbackConstraints = this.getConstraints(fallbackWidth, fallbackHeight, facingMode, audio);

                logError = function logError(e) {
                  return console.log('error', e, __WEBPACK_IMPORTED_MODULE_25__babel_runtime_corejs3_helpers_typeof___default()(e));
                };

                onSuccess = function onSuccess(stream) {
                  var _context5;

                  Webcam.userMediaRequested = false;

                  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_for_each___default()(_context5 = Webcam.mountedInstances).call(_context5, function (instance) {
                    return instance.handleUserMedia(stream);
                  });
                };

                onError = function onError(e) {
                  Webcam.userMediaRequested = false;
                  logError(e);

                  var isPermissionError = __WEBPACK_IMPORTED_MODULE_23__babel_runtime_corejs3_core_js_stable_instance_includes___default()(permissionErrors).call(permissionErrors, e.name);

                  if (isPermissionError || hasTriedFallbackConstraints) {
                    var _context6;

                    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_for_each___default()(_context6 = Webcam.mountedInstances).call(_context6, function (instance) {
                      return instance.handleError(e);
                    });
                  } else {
                    hasTriedFallbackConstraints = true;
                    getUserMedia(fallbackConstraints).then(onSuccess)["catch"](onError);
                  }
                };

                Webcam.userMediaRequested = true;
                _context9.prev = 9;
                _context9.next = 12;
                return __WEBPACK_IMPORTED_MODULE_30_enumerate_devices___default()();

              case 12:
                devices = _context9.sent;
                hasDevicePermission = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_every___default()(_context7 = __WEBPACK_IMPORTED_MODULE_20__babel_runtime_corejs3_core_js_stable_instance_filter___default()(devices).call(devices, function (_ref) {
                  var kind = _ref.kind;
                  return kind === "videoinput";
                })).call(_context7, function (_ref2) {
                  var label = _ref2.label;
                  return !!label;
                }); // If some 'videoinput' devices do no contains label, permission is not granted yet.

                if (hasDevicePermission) {
                  _context9.next = 19;
                  break;
                }

                _context9.next = 17;
                return getUserMedia({
                  video: true,
                  audio: audio
                });

              case 17:
                mediaStream = _context9.sent;

                __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_for_each___default()(_context8 = mediaStream.getVideoTracks()).call(_context8, function (stream) {
                  return stream.stop();
                });

              case 19:
                _context9.t0 = getUserMedia;
                _context9.next = 22;
                return handleFacingModeConstraints(constraints);

              case 22:
                _context9.t1 = _context9.sent;
                _context9.next = 25;
                return (0, _context9.t0)(_context9.t1);

              case 25:
                this.stream = _context9.sent;

                if (this.stream) {
                  onSuccess(this.stream);
                }

                _context9.next = 32;
                break;

              case 29:
                _context9.prev = 29;
                _context9.t2 = _context9["catch"](9);
                onError(_context9.t2);

              case 32:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee2, this, [[9, 29]]);
      }));

      function requestUserMedia() {
        return _requestUserMedia.apply(this, arguments);
      }

      return requestUserMedia;
    }()
  }, {
    key: "handleError",
    value: function handleError(error) {
      this.setState({
        hasUserMedia: false
      });
      this.props.onFailure(error);
    }
  }, {
    key: "handleUserMedia",
    value: function handleUserMedia(stream) {
      var videoSettings = stream ? stream.getVideoTracks()[0].getSettings() : {}; // check for stream, assign empty object if none

      this.stream = stream;
      debugConsole('video track settings', videoSettings);
      var facingMode = this.props.facingMode;
      /* If the facingMode for the webcam was passed in as "environment" or {exact: "environment"} we don't want to mirror the video stream,
      since we will be seeing  the stream of the rear camera*/

      var isVideoStreamForRearCamera = facingMode === "environment" || facingMode && facingMode.exact && facingMode.exact === "environment";
      this.setState({
        hasUserMedia: true,
        mirrored: !isVideoStreamForRearCamera && (videoSettings.facingMode === 'user'
        /* #HACK desktop cameras seem to have `facingMode` undefined,
        therefore we are assuming all desktop cameras are user facing*/
        || !videoSettings.facingMode)
      });
      this.props.onUserMedia();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _context10,
          _context11,
          _this2 = this;

      var index = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_index_of___default()(_context10 = Webcam.mountedInstances).call(_context10, this);

      __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_splice___default()(_context11 = Webcam.mountedInstances).call(_context11, index, 1);
      /*
      We need to call `stopStreamTracks` since otherwise devices will continue
      holding onto the stream (e.g. recording through the webcam, even though we
      no longer need the stream)
      However - some devices (namely iOS Safari) have issues with calling
      `getUserMedia` multiple times from cold (i.e. without any existing streams
      already running in the background), so we don't stop the stream for
      `stopDelay` milliseconds, in an attempt to re-use the same stream, if a new
      component is mounted soon after.
      This issue of iOS Safari was pinpointed by unmounting and remounting the
      webcam component multiple times, and confirming that the error occurred in
      the `getUserMedia` request - and then testing that the error did _not_ occur
      if we never called `.stop()` on the tracks (however we do need to relinquish
      the stream eventually)
      The precise value for `stopDelay` is a finger-in-the-air value, that is
      a nice balance between the stream being relinquished (so the webcam light
      turns off etc.), and the crash not occuring (because of the wait)
      */


      var stopDelay = 1000;

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_set_timeout___default()(function () {
        return stopStreamTracks(_this2.stream);
      }, stopDelay);
    }
  }, {
    key: "getScreenshot",
    value: function getScreenshot() {
      var canvas = this.getCanvas();
      if (!canvas) return null;
      return canvas.toDataURL(this.props.screenshotFormat);
    }
  }, {
    key: "getCanvas",
    value: function getCanvas() {
      var _context12;

      if (!this.state.hasUserMedia || !this.video) return null;
      var video = this.video;
      if (!this.canvas) this.canvas = document.createElement('canvas');
      var canvas = this.canvas;
      if (!this.ctx) this.ctx = canvas.getContext('2d');
      var ctx = this.ctx; // This is set every time incase the video element has resized

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      debugConsole(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context12 = "drawn image to canvas: ".concat(canvas.width, "x")).call(_context12, canvas.height));
      return canvas;
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      this.mediaRecorder = Object(__WEBPACK_IMPORTED_MODULE_28__video__["a" /* createMediaRecorder */])(this.stream);
      this.recordedBlobs = Object(__WEBPACK_IMPORTED_MODULE_28__video__["b" /* startRecording */])(this.mediaRecorder);
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      this.mediaRecorder.stop(this.recordedBlobs);
    }
  }, {
    key: "getVideoBlob",
    value: function getVideoBlob() {
      var mimeType = this.mediaRecorder.mimeType;
      var type = mimeType.split(';')[0]; // mimeType (excluding the codec)

      return new Blob(this.recordedBlobs, {
        type: type
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // React will try and optimise this on re-mounts, so make sure to explicitly
      // not render with a stream that no longer exists
      // This is likely related to https://github.com/onfido/onfido-sdk-ui/blob/249f54264f3a1674a2702b95967bb91ec6e3b90d/src/components/Confirm/index.js#L37
      // as the `video` element should not _should_ not show anything if the stream
      // is `null` anyway
      if (!this.stream) return null;
      return __WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("video", {
        style: {
          // not necessary to add prefixes, since all browsers that support camera
          // support transform
          transform: this.state.mirrored ? 'scaleX(-1)' : ''
        },
        ref: function ref(el) {
          return _this3.video = el;
        } // the `muted` attribute must be true for recording videos
        // Due to a bug in React, setting this attribute inside the video element does not currently work
        // so we update it in the  `updateVideoElement()` function
        // the muted attribute must be true and should be used in conjuction with `playsinline="true"` and `autoPlay="true"`, in order to prevent the "Live Broadcast" screen in iOS Safari
        ,
        muted: true,
        autoPlay: true,
        playsinline: true // necessary for iOS, see https://github.com/webrtc/samples/issues/929
        ,
        srcObject: this.stream,
        className: this.props.className
      });
    }
  }]);

  return Webcam;
}(__WEBPACK_IMPORTED_MODULE_27_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty___default()(Webcam, "defaultProps", {
  audio: false,
  screenshotFormat: 'image/webp',
  onUserMedia: function onUserMedia() {},
  onFailure: function onFailure() {}
});

__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty___default()(Webcam, "mountedInstances", []);

__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs3_helpers_defineProperty___default()(Webcam, "userMediaRequested", false);



/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_18__;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_23__;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_26__;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_27__;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_28__;

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMediaRecorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startRecording; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_objectSpread__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_objectSpread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_objectSpread__);

var MediaRecorder = window.MediaRecorder;

var handleDataAvailable = function handleDataAvailable(event, recordedBlobs) {
  if (event.data && event.data.size > 0) {
    recordedBlobs.push(event.data);
  }
};

var handleStop = function handleStop(event) {
  console.log('Recorder stopped: ', event);
};

var videoOptions = function videoOptions() {
  // TODO, These values are the same the MediaRecorder should have by default.
  // We identified that in recent Safari versions the defaults were not being respected
  // thus we have to add them here to ensure we control the bitrate and keep file sizes reasonable.
  //
  // Future improvement would be to make these configurable thru the webcam component if we have
  // different scenarios that require different bitrates on the web sdk
  var bitRate = {
    audioBitsPerSecond: 128000,
    videoBitsPerSecond: 2500000
  };
  var mimeTypes = ['video/webm;codecs=vp8,opus', 'video/webm;codecs=vp8', 'video/webm;codecs=vp9', 'video/webm'];
  var mimeType = '';

  for (var type in mimeTypes) {
    if (MediaRecorder.isTypeSupported(mimeTypes[type])) {
      mimeType = mimeTypes[type];
      break;
    } else {
      console.log("".concat(mimeTypes[type], " is not Supported"));
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_objectSpread___default()({}, bitRate, {
    mimeType: mimeType ? mimeType : ''
  });
};

var createMediaRecorder = function createMediaRecorder(stream) {
  var options = videoOptions();

  try {
    return new MediaRecorder(stream, options);
  } catch (e) {
    console.error("Exception while creating MediaRecorder: ".concat(e));
    return;
  }
};
var startRecording = function startRecording(mediaRecorder) {
  var recordedBlobs = [];
  mediaRecorder.onstop = handleStop;

  mediaRecorder.ondataavailable = function (e) {
    return handleDataAvailable(e, recordedBlobs);
  };

  mediaRecorder.start(10); // collect 10ms of data

  console.log('MediaRecorder started', mediaRecorder);
  return recordedBlobs;
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_30__;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backCameraKeywords; });
/**
 * Used this package as reference https://unpkg.com/browse/scandit-sdk@4.6.1/src/lib/cameraAccess.ts
 *
 * Handle localized camera labels. Supported languages:
 * English, German, French, Spanish (spain), Portuguese (brasil), Portuguese (portugal), Italian,
 * Chinese (simplified), Chinese (traditional), Japanese, Russian, Turkish, Dutch, Arabic, Thai, Swedish,
 * Danish, Vietnamese, Norwegian, Polish, Finnish, Indonesian, Hebrew, Greek, Romanian, Hungarian, Czech,
 * Catalan, Slovak, Ukraininan, Croatian, Malay, Hindi.
 */
var backCameraKeywords = ["rear", "back", "world", "rück", "arrière", "trasera", "trás", "traseira", "posteriore", "后面", "後面", "背面", "后置", // alternative
"後置", // alternative
"背置", // alternative
"задней", "الخلفية", "후", "arka", "achterzijde", "หลัง", "baksidan", "bagside", "sau", "bak", "tylny", "takakamera", "אחורית", "πίσω", "spate", "hátsó", "zadní", "darrere", "zadná", "задня", "stražnja", "belakang", "बैक"];

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (cb) {
    if (typeof Promise !== 'function') {
      var err = new Error('Device enumeration not supported.');
      err.kind = 'METHOD_NOT_AVAILABLE';
      if (cb) {
          console.warn('module now uses promise based api - callback is deprecated');
          return cb(err);
      }
      throw err;
    }

    return new Promise(function(resolve, reject) {
        var processDevices = function (devices) {
            var normalizedDevices = [];
            for (var i = 0; i < devices.length; i++) {
                var device = devices[i];
                //make chrome values match spec
                var kind = device.kind || null;
                if (kind && kind.toLowerCase() === 'audio') {
                    kind = 'audioinput';
                } else if (kind && kind.toLowerCase() === 'video') {
                    kind = 'videoinput';
                }
                normalizedDevices.push({
                    facing: device.facing || null,
                    deviceId: device.id || device.deviceId || null,
                    label: device.label || null,
                    kind: kind,
                    groupId: device.groupId || null
                });
            }
            resolve(normalizedDevices);
            if (cb) {
                console.warn('module now uses promise based api - callback is deprecated');
                cb(null, normalizedDevices);
            }
        };

        if (window.navigator && window.navigator.mediaDevices && window.navigator.mediaDevices.enumerateDevices) {
            window.navigator.mediaDevices.enumerateDevices().then(processDevices);
        } else if (window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
            window.MediaStreamTrack.getSources(processDevices);
        } else {
            var err = new Error('Device enumeration not supported.');
            err.kind = 'METHOD_NOT_AVAILABLE';
            reject(err);
            if (cb) {
                console.warn('module now uses promise based api - callback is deprecated');
                cb(err);
            }
        }
    });
};


/***/ })
/******/ ]);
});